import React, { useState, useMemo } from 'react';
import VirtualFriendsList from './../VirtualFriendsList/VirtualFriendsList';
import styles from './FriendsList.module.css';
import { useTranslation } from 'react-i18next';
import { HiUserGroup, HiTrash } from 'react-icons/hi2';
import Button from '../../ui/Button';

export default function FriendsList({ friends, onView, onRemove, isLoading, onFindFriends }) {
  const [search, setSearch] = useState('');
  const { t } = useTranslation();
  // Group by status
const groups = useMemo(() => {
  const map = { online: [], away: [], offline: [] };
  if (!Array.isArray(friends)) return map;

	
  friends.forEach(f => {
	const key = ['online', 'away', 'offline'].includes(f.status) ? f.status : 'offline';
    map[key].push(f);
  });
  return map;
}, [friends]);


const filteredGroups = useMemo(() => {
  if (!friends || !Array.isArray(friends)) return { online: [], away: [], offline: [] };

  const query = search.toLowerCase();
  return Object.fromEntries(
    Object.entries(groups).map(([key, arr]) => [
      key,
      arr.filter(f => f.username?.toLowerCase().includes(query))
    ])
  );
}, [groups, search, friends]);

if (isLoading) {
  return <div className={styles.loading}>Loading friends...</div>;
}

const allEmpty = Object.values(filteredGroups).every(g => g.length === 0);

return (
    <div className={styles.section}>
      <h4 className={styles.sectionTitle}><HiUserGroup /> {t('friends.list')}</h4>
		  <div className={styles.container}>
			<input
			  className={styles.search}
			  type="search"
			  placeholder="Search friends..."
			  value={search}
			  onChange={(e) => setSearch(e.target.value)}
			/>

			{allEmpty ? (
				<div className={styles.empty}>
					<p>You haven't added any friends yet.</p>
					<p>Join debates, search for users, and grow your network!</p>
					<Button variant={'secondary'} className={styles.exploreBtn} onClick={onFindFriends}>
					  Find Friends
					</Button>
				</div>
			) : (
			  Object.entries(filteredGroups).map(([status, arr]) => (
				arr.length > 0 && (
				  <div key={status} className={styles.group}>
					<h5 className={styles.groupTitle}>{status.charAt(0).toUpperCase() + status.slice(1)}</h5>
					<VirtualFriendsList
					  friends={arr}
					  onView={onView}
					  onRemove={onRemove}
					/>
				  </div>
				)
			  ))
			)}
		  </div>
  </div>
);

}
